import { useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import { COLOR_WHITE } from '../templates/colors';
import queryString from 'query-string';

const ROOT_WIDTH = 900;
const ROOT_HEIGHT = 600;
const PIXEL_DENSITY_FACTOR = 2;
const getScaleFactor = (props)=> props && !isNaN(props.scaleFactor) ? props.scaleFactor : PIXEL_DENSITY_FACTOR;
const getRootWidth = (props)=> props && props.rootWidth ? props.rootWidth : ROOT_WIDTH;
const getRootHeight = (props)=> props && props.rootHeight ? props.rootHeight : ROOT_HEIGHT;

const useStyles = makeStyles((theme)=> ({
    root: {
        width: (props)=> getRootWidth(props) * getScaleFactor(props),
        height: (props)=> getRootHeight(props) * getScaleFactor(props),
        position: 'relative',
        overflow: 'hidden',
        backgroundColor: COLOR_WHITE,
        textRendering: 'optimizeLegibility',
        borderRadius: (props)=> props && props.borderRadius ? props.borderRadius : 0,
        zoom: ({ templateRootZoom })=> templateRootZoom,
    },
    viewport: {
        display: 'block',
        position: 'relative',
        width: '100%',
        height: '100%',
        zoom: (props)=> getScaleFactor(props),
    },
}));

export function useShareablesTemplateRoot(props){
    const location = useLocation();
    let parsedData = props.data || null;
    let currentFrame = props.frame || 1;
    let templateRootZoom = props.zoom || 1;
    const onImagesLoaded = props.onImagesLoaded;
    if(!parsedData) {
        try {
            const { data, frame, zoom } = queryString.parse(location.search);
            parsedData = JSON.parse(data);
            currentFrame = parseInt(frame, 10);
            if(zoom && !isNaN(parseFloat(zoom))) templateRootZoom = parseFloat(zoom);
        } catch(e) {
            console.error(e);
        }
    }
    const imageDimensions = parsedData && parsedData.image_dimensions;
    const rootWidth = imageDimensions && imageDimensions.w ? imageDimensions.w : ROOT_WIDTH;
    const rootHeight = imageDimensions && imageDimensions.h ? imageDimensions.h : ROOT_HEIGHT;
    const rootClasses = useStyles({ templateRootZoom, ...props, rootWidth, rootHeight });

    return {
        rootClasses,
        parsedData,
        currentFrame,
        onImagesLoaded
    };
}